import React from 'react';

import { Box, Chip, Typography } from '@mui/material';

import { GHAProperty } from '~/services/ConnectionGoogleService';

interface Props {
  row: GHAProperty;
  onDeleteRegion: (propertyId: string, region: string, currentRegions: Array<string>) => void;
}

function PricingRegionsCell({ row, onDeleteRegion }: Props) {
  const regions = row.pricing_regions || [];

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center', width: '100%' }}>
      {regions.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      ) : (
        regions.map((region) => (
          <Chip
            key={region}
            label={region}
            size="small"
            onDelete={(e) => {
              e.stopPropagation();
              onDeleteRegion(row.id, region, regions);
            }}
          />
        ))
      )}
    </Box>
  );
}

export default PricingRegionsCell;
